import * as React from 'react'
import { StackActions } from '@react-navigation/native'
import { Platform } from "react-native"

export const navigationRef = React.createRef()

export function navigate(name, params) {
  navigationRef.current?.navigate(name, params)
}

export function replace(name, params) {
  navigationRef.current?.dispatch(StackActions.replace(name, params))
}

export function getCurrentStackName() {
  if (Platform.OS !== 'web') {
    const navigation = navigationRef.current
    const routes = navigation?.getRootState()?.routes ?? null
    if (routes === null) return 'app'
    const stackName = routes[routes.length - 1]?.name
    return stackName ?? 'app'
  }
  const url = window.location.pathname
  if (url.includes('julevenner')) return 'christmasFriends'
  const universeNamePattern = /u\/(?<universeName>\w+)/
  const matches = url.match(universeNamePattern)
  const universeName = matches?.groups?.universeName ?? null
  if (universeName !== null) return 'universe'
  return 'app'
}
